import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      // If not on home page, navigate to home first
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <span className="logo-icon">💳</span>
            <span className="logo-text">Shini Pay</span>
          </Link>
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            <a href="#features" onClick={() => scrollToSection('features')}>
              Fonctionnalités
            </a>
            <a href="#how-to-use" onClick={() => scrollToSection('how-to-use')}>
              Comment utiliser
            </a>
            <a href="#screenshots" onClick={() => scrollToSection('screenshots')}>
              Captures d'écran
            </a>
            <a href="#contact" onClick={() => scrollToSection('contact')}>
              Contact
            </a>
            <Link to="/privacy" onClick={() => setIsMenuOpen(false)}>
              Confidentialité
            </Link>
          </nav>
          <button
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;

